'use client';

import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { Branch } from '@medprev-web-app/api-graphql-client';

import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { googleMapsBaseUrl } from '@/utils/consts/google-maps.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchAddressProps {
  branch: Branch;
}

export const BranchAddress = ({ branch }: BranchAddressProps) => {
  return (
    <>
      {branch.address && (
        <section>
          <div className="flex items-start gap-2 mb-5">
            <Icon icon={faLocationDot} className="text-gray-500 w-5 h-5 mt-1" />
            <Typography
              variant={TypographyVariant.MEDIUM_SUBTITLE}
              className="font-semibold"
            >
              Endereço
            </Typography>
          </div>
          <div className="flex flex-col">
            <Typography variant={TypographyVariant.BODY_TEXT} className="mb-2">{branch.formattedAddress || ''}</Typography>
            <Link
              prefetch={false}
              target="_blank"
              rel="noopener noreferrer"
              href={`${googleMapsBaseUrl}${`Medprev ${branch.googleMapsAddress || ''}`}`}
              className="text-green-500 font-semibold hover:underline"
              data-analytics-event={AnalyticsEnum.CLICK_OPEN_MAP_BRANCH}
            >
              Abrir no mapa
            </Link>
          </div>
        </section>
      )}
    </>
  );
};
